// eslint-disable-next-line import/prefer-default-export
export const noForbiddenTemplateCharacters =
	() =>
	(data: string): string | null => {
		if (/[|<>]/.test(data)) {
			return 'value may not contain any of the following characters: < > |';
		}
		return null;
	};
